import { useState } from "react";

import FormInput from "../form-input/form-input.component";
import Button, { BUTTON_TYPE_CLASSES } from "../button/button.component";

import {
  createAuthUserWithEmailAndPassword,
  createUserDocumentFromAuth,
} from "../../utils/firebase/firebase.utils";
import { useNavigate } from "react-router-dom";
import {
  SignUpContainer,
  FormContainer,
  WelcomeText,
  ButtonContainer,
  HorizontalRule,
  SignUpPage,
} from "./sign-up-form.styles";
import AnimationPage from "../smallcomponents/animation.component";
import { toast, ToastContainer } from "react-toastify";

const defaultFormFields = {
  displayName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const SignUpForm = () => {
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { displayName, email, password, confirmPassword } = formFields;

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const navigate = useNavigate();

  const signInNavigationHandler = () => navigate("/auth");

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      toast("passwords do not match");
      return;
    }

    try {
      const { user } = await createAuthUserWithEmailAndPassword(
        email,
        password
      );

      await createUserDocumentFromAuth(user, { displayName });
      resetFormFields();
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        toast("Cannot create user, email already in use");
      } else {
        toast("user creation encountered an error", error);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <AnimationPage>
      <SignUpContainer>
        <FormContainer onSubmit={handleSubmit}>
          <WelcomeText>Sign up with your email and password</WelcomeText>

          <FormInput
            label="Display Name"
            type="text"
            required
            onChange={handleChange}
            name="displayName"
            value={displayName}
          />

          <FormInput
            label="Email"
            type="email"
            required
            onChange={handleChange}
            name="email"
            value={email}
          />

          <FormInput
            label="Password"
            type="password"
            required
            onChange={handleChange}
            name="password"
            value={password}
          />

          <FormInput
            label="Confirm Password"
            type="password"
            required
            onChange={handleChange}
            name="confirmPassword"
            value={confirmPassword}
          />

          <ButtonContainer>
            <Button type="submit">Sign Up</Button>
          </ButtonContainer>
          <HorizontalRule />
          <SignUpPage>
            <p>Already a part of our community?</p>
            <Button
              buttonType={BUTTON_TYPE_CLASSES.animated}
              onClick={signInNavigationHandler}
            >
              Sign-In
            </Button>
          </SignUpPage>
        </FormContainer>
      </SignUpContainer>
      <ToastContainer />
    </AnimationPage>
  );
};

export default SignUpForm;
